import usePlaceholder from 'articleEditor/hooks/usePlaceholder';
import {
  basicBlockActions,
  getTransformBlockActions,
} from 'articleEditor/utils/actions';
import { MyHeadingLargeElement } from 'lib-knowledge-document-structure/plateTypes';
import { RenderElementProps } from 'lib-knowledge-document-structure/slate/react';
import { useMemo } from 'react';

import s from '../baseBlock/block.module.scss';
import SortableBlockWrapper from '../baseBlock/sortableBlockWrapper';

type Props = RenderElementProps & {
  element: MyHeadingLargeElement;
};

export default function LargeHeadingBlock({
  attributes,
  element,
  children,
}: Props): JSX.Element {
  const placeholder = usePlaceholder({
    placeholder: 'Large Heading',
    element,
  });
  const blockActions = useMemo(
    () => [...basicBlockActions, ...getTransformBlockActions(element.type)],
    [element.type],
  );
  return (
    <SortableBlockWrapper
      className={s['blockLargeHeading']}
      element={element}
      blockActions={blockActions}
    >
      <div
        {...attributes}
        className={s['blockContent']}
        data-placeholder={placeholder}
      >
        {children}
      </div>
    </SortableBlockWrapper>
  );
}
